import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Svg from '../helpers/svg';
import PageHeader from '../helpers/pageHeader';
import fpRest from '../helpers/fpRest';
import CsvImporter from '../helpers/csvImporter';
import List from '../helpers/list';
import {defaultTableFilter, DorpDownFilter} from '../helpers/tableHelpers';
import ReactTable from 'react-table';
import Loader from 'react-loader-advanced';
import Alert from 'react-s-alert';
import usStatesObj from 'datasets-us-states-abbr-names';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-table/react-table.css';

const usStatesOptions = Object.keys(usStatesObj).reduce((acc, abbr) => {
    acc.push({label: usStatesObj[abbr], value: abbr}, {label: abbr, value: abbr});
    return acc;
}, []);

class BusinessAssociates extends Component {
    constructor(props) {
        super(props);
        const initSortOrder = sessionStorage.getItem(`businessAssociates:sortOrder`);

        this.state = {
            showLoader: true,
            initSortOrder: initSortOrder ? JSON.parse(initSortOrder) : {id: 'name', desc: false},
            businessAssociates: [],
            businessAssociatesActive: [],
            businessAssociateTypes: [],
            isImporterOpen: false,
            hideInactive: true,
            isImportDropdownOpen: false      
        };
    };

    getData = () => {
        if (this.state.showLoader === false) this.setState({showLoader: true});

        fpRest.get('business-associates')
        .then(res => {
            const businessAssociates = res.data;
            const businessAssociatesActive = businessAssociates.filter(({active}) => active);
            console.log(businessAssociatesActive);
            this.setState({businessAssociates, businessAssociatesActive, showLoader: false});
        })
        .catch(err => console.log(err));          
    };

    startImport = () => {
        this.setState({isImporterOpen: true});
    };

    closeImporter = () => {
        this.setState({isImporterOpen: false});
    };

    toggleImportDropdown = () => {
        this.setState({isImportDropdownOpen:!this.state.isImportDropdownOpen});
    };    

    toggleInactive = () => {
        this.setState({hideInactive: !this.state.hideInactive});
    };

    uploadBusinessAssociates = businessAssociates => {
        const getData = this.getData.bind(this);
        const policyPromises = businessAssociates.map(businessAssociate => fpRest.post('business-associates', {...businessAssociate, active: 1}));
        Promise.all(policyPromises)
        .then(res => {
            getData();
            Alert.success('Business Associates Uploaded');
        })
        .catch(err => { 
            if (err.response && err.response.data) {
                err.response.data.errors.forEach(err => {
                    Alert.error(`import failed: ${err}`);
                });
                console.log(err.response.data);
            }
            else {
                console.log(err);
                Alert.error(`Oops! Something didn't work right. Business Associates weren't imported`);
            }
        });
    };

    printAll = () => {
        console.log('Print All');
    };

    componentDidMount() {
        this.getData();        
    }

    render() {
        const {toggleImportDropdown, startImport, closeImporter, uploadBusinessAssociates, toggleInactive} = this;
        const {showLoader, initSortOrder, businessAssociates, businessAssociatesActive, hideInactive, isImporterOpen, isImportDropdownOpen} = this.state;
   
        return (
            <Loader show={showLoader} message={<Svg use="loader"/>} disableDefaultStyles={true}>
                <PageHeader title="Business Associates" actionItems={[
                    {label: <Svg use="add" />, tip: 'New BA', link: '/business-associates/new'},
                    {label: <Svg use="upload" />, tip: 'Upload BA', options: [{label: 'Select CSV File', action: startImport}, {label: 'Download Import Template', link: 'https://s3.amazonaws.com/flightplan-public/import-templates/business-associates-impot-template.csv', target: "_self"}], isOpen: isImportDropdownOpen, action: toggleImportDropdown}
                ]} />
                <section>
                    <List
                        className="meta"
                        inlineLabels={true}
                        items ={[
                            {label: 'Active Business Associates', value: businessAssociatesActive.length},
                            {label: 'Hide Inactive', value: hideInactive, editing: true, inputType: 'toggle', onChange: toggleInactive}
                        ]}
                    />
                </section>
                <section>
                    <div className="card">                      
                        <ReactTable
                            data={hideInactive ? businessAssociatesActive : businessAssociates}
                            defaultSorted={[initSortOrder]}
                            columns={[            
                                {Header: 'id', accessor: 'id', show: false},
                                {
                                    Header: 'Company Name',
                                    accessor: 'name',
                                },
                                {
                                    Header: 'Company Type',
                                    accessor: 'type',
                                    Cell: row => row.value ? <span>{row.value}</span> : 'Not Set'
                                },
                                {
                                    Header: 'Primary Contact',
                                    accessor: 'primaryContact',
                                    Cell: row => row.value ? <span>{row.value}</span> : 'Not Set'
                                },
                                {
                                    show: hideInactive ? false : true,
                                    Header: 'Active',
                                    accessor: 'active',
                                    Cell: row => row.value ? 'Active' : 'Inactive',
                                    Filter: ({onChange}) => <DorpDownFilter options={[{label: 'Active', value: true}, {label: 'inactive', value: false}]} action={onChange.bind(this)}/>            
                                }
                            ]}
                            noDataText="No Business Associates Found"
                            onSortedChange={sort => sessionStorage.setItem(`businessAssociates:sortOrder`, JSON.stringify(sort[0]))}
                            filterable={true}
                            defaultFilterMethod={defaultTableFilter}
                            getTdProps={(state, rowInfo, column, instance) => ({
                                onClick: e => rowInfo && this.props.history.push(`/business-associates/${rowInfo.row.id}`),
                                style: { cursor: 'pointer' }
                            })}
                        />
                    </div>
                </section>
                <Alert stack={{limit: 3}} effect="slide" html={true} />
                <CsvImporter
                    open={isImporterOpen}
                    onRequestClose={closeImporter}
                    onRequestUpload={res => uploadBusinessAssociates(res)}
                    title="Map Business Associate Fields"
                    mappingOptions={[
                        {label: 'Company Name', value: 'name', required: true},
                        {label: 'Address 1', value: 'address1'},
                        {label: 'Address 2', value: 'address2'},
                        {label: 'City', value: 'city'},
                        {
                            label: 'State',
                            value: 'state',
                            allowedCellValues: [{value: '', label: ''}, ...usStatesOptions]                          
                        },
                        {label: 'Zip', value: 'zip'},
                        {label: 'Phone 1', value: 'phone1'},
                        {label: 'Phone 2', value: 'phone2'},
                        {label: 'Fax 1', value: 'fax1'},
                        {label: 'Fax 2', value: 'fax2'},
                        {label: 'Website', value: 'website'},
                        {
                            label: 'Type',
                            value: 'typeId',
                            allowedCellValues: [
                                {value: '', label: ''},
                                {value: 1, label: 'Covered Entity'},
                                {value: 2, label: 'Business Associate'}
                            ]                       
                        },
                        {
                            label: 'Active',
                            value:'active',
                            required: true,
                            allowedCellValues: [
                                {value: true, label: 'Yes'},
                                {value: false, label: 'No'},
                                {value: true, label: 'True'},
                                {value: false, label: 'False'},
                                {value: true, label: '1'},
                                {value: false, label: '0'}                                                          
                            ]
                        }
                    ]}
                />
           </Loader>
        );
    };
}

export default withRouter(BusinessAssociates);